import * as React from 'react';

import type {QuoteDisplayStatus} from 'nutshell-graphql-types';

import {Button} from '../button/button';
// @ts-expect-error - imported from .js/.jsx file
import {UpgradeArrowIcon} from '../icon/svg/upgrade-arrow-icon';
import type {SalesDocumentType} from '../lead-sidebar/sales-documents/types';
import {Link} from '../link/link';
import {SelectMenu} from '../select-menu/select-menu';
import type {SelectMenuOption} from '../select-menu/select-menu';

import {getNextAdvanceableStatus, getPrimaryActionButtonText} from './helpers';
import {getDialogCopy} from './status/helpers';
import {StatusDialog} from './status/status-dialog';

type Props = {
    type: SalesDocumentType;
    sendOptions: SelectMenuOption[];
    displayStatus: QuoteDisplayStatus;
    handleUpdateStatus: (status: QuoteDisplayStatus) => void;
};

export function QuotePrimaryActionButton(props: Props) {
    const [isViewingSendOptions, setIsViewingSendOptions] = React.useState(false);
    const [isStatusDialogOpen, setIsStatusDialogOpen] = React.useState(false);
    const primaryActionButtonRef = React.useRef<HTMLElement | null | undefined>(null);

    const handlePrimaryActionClick = () => {
        // For invoices, we have another intermediary popover before the status
        // changes to paid so we don't need to show this one
        if (props.type === 'Invoice' && props.displayStatus === 'SENT') {
            props.handleUpdateStatus('ACCEPTED');
        } else if (props.displayStatus === 'PUBLISHED') {
            setIsViewingSendOptions(true);
        } else {
            setIsStatusDialogOpen(true);
        }
    };

    return (
        <>
            {NutClientConfig.hasQuotePlan || props.displayStatus !== 'DRAFT' ? (
                <Button
                    variant='primary'
                    size='big'
                    onClick={handlePrimaryActionClick}
                    fitContent={true}
                    getButtonRef={primaryActionButtonRef}
                >
                    {getPrimaryActionButtonText(props.displayStatus, props.type)}
                </Button>
            ) : (
                <Link
                    variant='button-upgrade'
                    icon={UpgradeArrowIcon}
                    size='big'
                    href={
                        props.type === 'Quote' ? '/sales/quote-upgrade' : '/sales/invoice-upgrade'
                    }
                >
                    Mark as ready
                </Link>
            )}
            {isStatusDialogOpen && primaryActionButtonRef.current && (
                <StatusDialog
                    anchor={primaryActionButtonRef.current}
                    copy={getDialogCopy(props.displayStatus, props.type)}
                    onPrimary={() => {
                        props.handleUpdateStatus(getNextAdvanceableStatus(props.displayStatus));
                        setIsStatusDialogOpen(false);
                    }}
                    onSecondary={() => setIsStatusDialogOpen(false)}
                />
            )}
            {isViewingSendOptions && (
                <SelectMenu
                    options={props.sendOptions}
                    anchor={primaryActionButtonRef.current}
                    location='bottom-left'
                    onClose={() => setIsViewingSendOptions(false)}
                />
            )}
        </>
    );
}
